import API from '../../../../common/http/api.fetch';
import {success, responseMessage, info} from '../../../../common/utils/util.notifier';
import { TYPES } from '../settings-action-type.constants';
//import { TYPES as ACC_TYPES } from '../../accreditation-action-type.constants';
import { IDS } from '../settings-action-id.constants';
import {GRID_FETCH} from "../../../../common/grid/grid.constants";
//import { IDS as ACC_IDS } from '../../accreditation-action-id.constants';

export const getFrameworkRequirementDetails = (node) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/framework-requirement-details',
            method: 'GET',
            params: {id: node.id}
        }).then(response => {
            dispatch({
                type:   TYPES.REQUIREMENT_DETAILS_REFRESH,
                id:     IDS.accreditationSettingsRequirementDetails,
                data:   {
                    ...response.data[0],
                    id:                 node.id,
                    sectionParentId:    node.sectionParentId,
                    level:              node.level,
                    nodeName:           node.name,
                    prefix:             node.number,
                    siblings:           node.children.map(item => parseInt(item.numberRaw.split('.').pop())),
                    schemeCode:         node.schemeCode,
                }
            })
            // dispatch({
            //     type: ACC_TYPES.SIMPLE_STD_TREE_SELECT,
            //     sectionId: node.id,
            // })
        }, error => {
            responseMessage(error);
        });
    };
}

export const addFrameworkRequirement = (data) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/add-framework-requirement',
            method: 'POST',
            data:   data,
        }).then(response => {
            dispatch({
                type:   TYPES.REQUIREMENT_DETAILS_REFRESH,
                id:     IDS.accreditationSettingsRequirementDetails,
                data:   {parent_id: data.parent_id},
            });
            success('ACCREDITATION.NOTIFICATIONS.SECTION.ADD')
        }, error => {
            responseMessage(error);
        })
    }
}

export const updateFrameworkRequirementDetails = (data) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/edit-framework-requirement',
            method: 'POST',
            data:   data,
        }).then(response => {
            dispatch({
                type:   TYPES.REQUIREMENT_DETAILS_REFRESH,
                id:     IDS.accreditationSettingsRequirementDetails,
                data:   data
            });
            success('ACCREDITATION.NOTIFICATIONS.SECTION.EDIT')
        }, error => {
            responseMessage(error);
        })
    }
}

export const removeFrameworkRequirement = (id) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/remove-framework-requirement',
            method: 'POST',
            data:   { id },
        }).then(() => {
            success('ACCREDITATION.NOTIFICATIONS.SECTION.DELETE')
        }, error => {
            responseMessage(error);
        })
    }
}

export const importRequirementsFile = (file_path, scheme_code) => {
    return dispatch => {
        return API.fetch({
            url: `/rco/import-framework-requirements`,
            method: 'POST',
            data: {
                scheme_code,
                file_path,
            },
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.IMPORT_SUCCESSFUL');
        },error => {
            responseMessage(error)
        });
    };
};

export const exportRequirementsFile = (scheme_code, downloadFile) => {
    info('Please wait...', false);
    return dispatch => {
        return API.fetch({
            url:    '/rco/export-framework-requirements',
            method: 'GET',
            params: { scheme_code }
        }).then(({data}) => {
            downloadFile('/' + data.path)
            success('Export Complete!');
        }, error => {
            responseMessage(error);
        });
    };
}

export const fetchRequirementsImportsGrid = (filter) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/list-requirements-imports-grid',
            method: 'GET',
            params: {
                ...filter,
                path: undefined,
            }
        }).then(({data}) => {
            dispatch({
                type:   GRID_FETCH,
                id:     IDS.accSettings,
                path:   filter.path,
                ...data,
                items: data.items.map( item => ({...item, dateTime: true})),
            })
        }, error => {
            responseMessage(error);
        })
    }
}